var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panda-svga"},[_c('div',{ref:"pandaSvgaCvs",attrs:{"id":"panda-svga-cvs","src":_vm.src,"loops":_vm.loops,"fillMode":_vm.fillMode,"clearsAfterStop":_vm.clearsAfterStop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }